// ── Patrimia — Traductions FR (locale par defaut) ──

export const fr = {
  common: {
    appName: 'Patrimia',
    loading: 'Chargement...',
    save: 'Enregistrer',
    cancel: 'Annuler',
    delete: 'Supprimer',
    archive: 'Archiver',
    search: 'Rechercher',
    filter: 'Filtrer',
    create: 'Creer',
    edit: 'Modifier',
    close: 'Fermer',
    all: 'Tous',
    confirm: 'Confirmer',
    back: 'Retour',
    next: 'Suivant',
    yes: 'Oui',
    no: 'Non',
    noResults: 'Aucun resultat',
    version: 'v0.1.0',
    copyright: 'Patrimia — IT-Transform',
    login: 'Connexion',
    logout: 'Déconnexion',
    selectAll: 'Tout sélectionner',
    clearAll: 'Tout effacer',
    selected: '{{n}} sélectionné(s)',
    bulkArchive: 'Archiver la sélection',
    archived: 'Archivé(s)',
  },
  nav: {
    dashboard: 'Tableau de bord',
    contacts: 'Contacts',
    mandats: 'Mandats',
    pipeline: 'Pipeline',
    mailbox: 'Messagerie',
    documents: 'Documents',
    settings: 'Parametres',
    admin: 'Administration',
    aria: 'Aria IA',
    // Budget nav
    budgetSynthese: 'Synthese',
    budgetPerso: 'Perso',
    budgetPro: 'Pro',
    budgetPatrimoine: 'Patrimoine',
    budgetTransactions: 'Transactions',
    budgetReconciliation: 'Reconciliation',
    budgetCharges: 'Budget Charges',
    budgetFinance: 'Budget',
    invest: 'Investissements',
    // Proprio nav
    proprio: 'Proprio',
    proprioBiens: 'Biens',
    proprioBaux: 'Baux',
    proprioCharges: 'Charges locatives',
    // Syndic nav
    syndicCoproprietes: 'Coproprietes',
    syndicAssemblees: 'Assemblees',
    // Notaire nav
    notaireEstimations: 'Estimations',
    notaireChecklists: 'Checklists',
    // Outils nav
    agenda: 'Agenda',
    tasks: 'Taches',
    glossaire: 'Glossaire',
    templates: 'Templates',
    integrations: 'Integrations',
    breadcrumb: {
      proprio: 'Proprio',
      biens: 'Biens',
      baux: 'Baux',
      loyers: 'Loyers',
      edl: 'Etats des lieux',
      indexation: 'Indexation',
      signalements: 'Signalements',
      preavis: 'Preavis',
      budget: 'Budget',
      perso: 'Perso',
      pro: 'Pro',
      patrimoine: 'Patrimoine',
      transactions: 'Transactions',
      reconciliation: 'Reconciliation',
      invest: 'Investissement',
      syndic: 'Syndic',
      ag: 'Assemblees',
      notaire: 'Notaire',
      checklists: 'Checklists',
      budgetCharges: 'Charges locatives',
      agenda: 'Agenda',
      tasks: 'Taches',
      glossaire: 'Glossaire',
      onboarding: 'Configuration',
    },
    portal: {
      espaceClient: 'Espace client',
      espaceLocataire: 'Espace locataire',
      acceder: 'Acceder au portail',
    },
    groups: {
      principal: 'Principal',
      crm: 'CRM',
      proprio: 'Gestion locative',
      syndic: 'Syndic',
      finance: 'Finance',
      notaire: 'Notaire',
      outils: 'Outils',
      admin: 'Admin',
    },
    sections: {
      crm: 'CRM Immobilier',
      proprio: 'Gestion Proprio',
      modules: 'Modules',
      syndic: 'Syndic',
      notaire: 'Outils Notaire',
      administration: 'Administration',
      compte: 'Mon compte',
    },
    sectionDescs: {
      crmDesc: 'Contacts, mandats, pipeline',
      proprioDesc: 'Biens, loyers, indexation',
      modulesDesc: 'Budget, investissement',
      syndicDesc: 'Coproprietes, appels de fonds',
      notaireDesc: 'Estimations, checklists',
      adminDesc: 'Equipe, billing, exports',
      compteDesc: 'Profil et parametres',
    },
  },
  dashboard: {
    title: 'Tableau de bord',
    subtitle: "Vue d'ensemble de votre activite — mars 2026",
    kpi: {
      activeMandats: 'Mandats actifs',
      visitsMonth: 'Visites ce mois',
      pendingOffers: 'Offres en attente',
      transactionsClosed: 'Transactions closes',
      pipelinePondere: 'Pipeline pondere',
      commissionsYtd: 'Commissions YTD',
      // legacy compat
      transactionsMonth: 'Transactions ce mois',
      visitsWeek: 'Visites cette semaine',
      pipelineValue: 'Valeur pipeline',
      commissionMonth: 'Commission mois',
    },
    kpiSection: 'Indicateurs cles',
    pipelineApercu: 'Apercu pipeline',
    pipelineFullView: 'Vue complete',
    dossiers: 'dossiers',
    stages: {
      visite: 'Visite',
      offre: 'Offre',
      compromis: 'Compromis',
      acte: 'Acte',
    },
    trends: {
      thisMonth: 'Ce mois',
      vsPrev: '— vs prec.',
      pending: 'En attente',
      pondere: 'Pondere',
      sinceJan: 'Depuis jan.',
    },
    subs: {
      noMandats: 'Aucun mandat enregistre',
      prevMonth: '0 le mois precedent',
      response48h: 'Reponse sous 48h',
      actesSignes: 'Actes signes ce mois',
      pipelineFormula: 'Prospect x10% · Offre x50% · Compromis x90%',
      objectif: 'Objectif : — € · 0% atteint',
    },
    panels: {
      alertes: 'Alertes & priorites',
      activite: 'Activite recente',
      aria: 'Aria — suggestions',
      voirTout: 'Tout voir',
      historique: 'Historique',
      details: 'Details',
      voir: 'Voir',
    },
    empty: {
      noAlerts: 'Aucune alerte active',
      alertsSub: 'Mandats expirant, documents bloquants et dossiers dormants',
      noActivity: 'Rien pour l\'instant',
      activitySub: 'Visites ajoutees, offres recues et mandats signes',
      importContacts: 'Importer des contacts',
      noSuggestions: 'Aucune suggestion',
      ariaSub: 'Aria analysera vos dossiers et proposera des actions prioritaires',
      noData: 'Aucune donnee',
    },
    recentActivity: 'Activite recente',
    alerts: 'Alertes',
    quickActions: 'Actions rapides',
    newMandat: '+ Mandat',
    newContact: '+ Contact',
    noActivity: 'Aucune activite recente',
    devRoleSwitcher: 'Simuler un role (/dashboard conditionnel)',
    roles: {
      agent: { label: 'Agent' },
      agencyAdmin: {
        label: 'Agency Admin',
        title: 'Mon agence',
        subtitle: 'Vue consolidee de l\'agence',
        kpi: {
          caYtd: 'CA YTD',
          mandatsSigns: 'Mandats signes',
          tauxTransfo: 'Taux transformation',
          nps: 'NPS moyen',
          leads: 'Leads ce mois',
          pipelinePrev: 'Pipeline previsionnel',
        },
        subs: {
          commissions: 'Commissions encaissees',
          newMandats: 'Nouveaux mandats',
          leadsToMandats: 'Leads → mandats signes',
          postTransaction: 'Post-transaction',
          leadsSources: 'Immoweb · vitrine · parrainage',
          caPrev30j: 'CA previsionnel 30 jours',
        },
        perfAgent: 'Performance par agent',
        noAgent: 'Aucun agent actif',
        inviteSub: 'Invitez votre equipe pour voir les performances',
        inviteBtn: 'Inviter un agent',
        treso: 'Tresorerie previsionnelle 6 mois',
        tresoSub: 'Alimentez le pipeline pour voir les projections',
        alertesManager: 'Alertes manager',
        alertesSub: 'Dossiers dormants, AML incomplet, agents inactifs 7j',
      },
      collaborator: {
        label: 'Collaborateur',
        title: 'Mon espace',
        subtitle: 'Stagiaire · assigne',
        today: 'Aujourd\'hui',
        visitesJour: 'Visites du jour',
        tachesDues: 'Taches dues',
        relancesAria: 'Relances Aria',
        tachesAssignees: 'Mes taches assignees',
        noTaches: 'Aucune tache assignee',
        tachesSub: 'Vos taches assignees par l\'agent apparaitront ici',
        pipelineRo: 'Pipeline (lecture seule)',
        noDossiers: 'Aucun dossier en cours',
        pipelineSub: 'Vous pouvez consulter les dossiers mais pas les modifier',
      },
      client: { label: 'Client' },
      locataire: { label: 'Locataire' },
      owner: {
        label: 'Proprio',
        title: 'Mes biens',
        subtitle: 'Patrimia Proprio',
        kpi: {
          biensLocation: 'Biens en location',
          loyersMois: 'Loyers du mois',
          signalements: 'Signalements ouverts',
        },
        subs: {
          noBien: 'Aucun bien enregistre',
          loyerDetail: '0 paye · 0 en attente',
          reparations: 'Reparations en cours',
        },
        trends: {
          moisCourant: 'Mars 2026',
        },
        panelBiens: 'Mes biens',
        ajouter: 'Ajouter',
        noBien: 'Aucun bien enregistre',
        bienSub: 'Ajoutez votre premier bien pour commencer la gestion locative',
        ajouterBien: 'Ajouter un bien',
        panelIndexation: 'Indexation PropTax',
        simuler: 'Simuler',
        noIndexation: 'Aucune indexation prevue',
        indexationSub: 'Les echeances d\'indexation apparaitront ici',
      },
      syndic: {
        label: 'Syndic',
        title: 'Syndic — Gestion de coproprietes',
        subtitle: 'Vue d\'ensemble de vos coproprietes, appels de fonds et assemblees.',
        kpi: {
          copros: 'Coproprietes gerees',
          lots: 'Lots totaux',
          appels: 'Appels de fonds emis',
          impayes: 'Impayes',
          ag: 'AG planifiees',
          tresorerie: 'Tresorerie globale',
        },
        subs: {
          copros: 'Nombre de coproprietes sous gestion',
          lots: 'Tous types confondus',
          appels: 'Trimestre en cours',
          impayes: 'Montant total des impayes > 30 jours',
          ag: 'Assemblees generales a venir',
          tresorerie: 'Solde consolide tous fonds',
        },
        panelSinistres: 'Sinistres en cours',
        noSinistre: 'Aucun sinistre signale',
        sinistreSub: 'Les sinistres et interventions urgentes apparaitront ici',
        panelAG: 'Prochaines AG',
        planifierAG: 'Planifier',
        noAG: 'Aucune AG planifiee',
        agSub: 'Planifiez votre prochaine assemblee generale',
      },
      notaire: {
        label: 'Notaire',
        title: 'Etude notariale — Outils immobiliers',
        subtitle: 'Estimations, checklists de conformite et suivi de dossiers.',
        kpi: {
          estimations: 'Estimations en cours',
          checklists: 'Checklists actives',
          dossiers: 'Dossiers ce mois',
        },
        subs: {
          estimations: 'Estimations de biens en attente de validation',
          checklists: 'Verifications de conformite en cours',
          dossiers: 'Actes et compromis en preparation',
        },
        panelEstimations: 'Estimations recentes',
        noEstimation: 'Aucune estimation en cours',
        estimationSub: 'Creez une estimation pour un bien immobilier',
        nouvelleEstimation: 'Nouvelle estimation',
        panelChecklists: 'Checklists de conformite',
        noChecklist: 'Aucune checklist en cours',
        checklistSub: 'Verifiez la conformite documentaire d\'un dossier',
        nouvelleChecklist: 'Nouvelle checklist',
      },
      portal: {
        title: 'Espace portail',
        message: 'Accedez au portail via le lien dedie. Le portail client et locataire dispose de son propre espace.',
        cta: 'Acceder au portail',
      },
    },
  },
  contacts: {
    title: 'Contacts',
    subtitle: 'Gerez vos contacts acheteurs, vendeurs, locataires et prospects.',
    create: 'Nouveau contact',
    types: {
      buyer: 'Acheteur',
      seller: 'Vendeur',
      tenant: 'Locataire',
      landlord: 'Proprietaire',
      prospect: 'Prospect',
    },
    fields: {
      firstName: 'Prenom',
      lastName: 'Nom',
      email: 'Email',
      phone: 'Telephone',
      type: 'Type',
      status: 'Statut',
      budget: 'Budget',
      source: 'Source',
      tags: 'Tags',
      notes: 'Notes',
    },
    empty: 'Aucun contact. Commencez par en creer un.',
    exportCsv: 'Exporter CSV',
  },
  mandats: {
    title: 'Mandats',
    subtitle: 'Mandats de vente et de location.',
    create: 'Nouveau mandat',
    status: {
      draft: 'Brouillon',
      active: 'Actif',
      'under-offer': 'Sous offre',
      compromis: 'Compromis',
      acte: 'Acte signe',
      expired: 'Expire',
      withdrawn: 'Retire',
    },
    fields: {
      reference: 'Reference',
      type: 'Type',
      price: 'Prix',
      address: 'Adresse',
      surface: 'Surface',
      rooms: 'Pieces',
      bedrooms: 'Chambres',
      status: 'Statut',
      agent: 'Agent',
      vendor: 'Vendeur',
    },
    empty: 'Aucun mandat. Creez votre premier mandat de vente.',
  },
  pipeline: {
    title: 'Pipeline',
    subtitle: 'Suivez vos transactions en cours.',
    stages: {
      'nouveau-contact': 'Nouveau contact',
      'visite-planifiee': 'Visite planifiee',
      'offre': 'Offre',
      'negociation': 'Negociation',
      'compromis': 'Compromis',
      'conditions': 'Conditions',
      'acte': 'Acte',
      'abandonne': 'Abandonne',
    },
    changeReason: 'Raison du changement',
    empty: 'Aucune transaction en cours.',
  },
  aria: {
    name: 'Aria',
    placeholder: 'Posez votre question a Aria...',
    disclaimer: 'Ce calcul est indicatif et ne constitue pas un avis fiscal officiel.',
    thinking: 'Aria reflechit...',
    suggestions: 'Suggestions Aria',
    noSuggestions: 'Aucune suggestion pour le moment.',
  },
  portal: {
    welcome: 'Bienvenue sur votre espace Patrimia',
    contactAgent: 'Contactez votre agent immobilier pour obtenir un nouveau lien.',
    dossier: 'Mon dossier',
    timeline: 'Avancement',
    documents: 'Documents',
    messages: 'Messages',
    sendMessage: 'Envoyer un message',
    noMessages: 'Aucun message',
    noDocuments: 'Aucun document disponible',
    // Tabs
    tabDossier: 'Dossier',
    tabOffres: 'Offres',
    tabEstimation: 'Estimation',
    tabConditions: 'Conditions',
    tabPostVente: 'Post-vente',
    tabBien: 'Catalogue',
    tabFaireOffre: 'Faire une offre',
    tabSimulateur: 'Simulateur',
    tabComparateur: 'Comparateur',
    tabFeedback: 'Mon avis',
    // KPIs vendeur
    kpiVisites: 'Visites',
    kpiOffres: 'Offres',
    kpiEtape: 'Etape',
    stages: {
      draft: 'Brouillon',
      active: 'Actif',
      'under-offer': 'Offre recue',
      compromis: 'Compromis',
      acte: 'Acte signe',
    } as Record<string, string>,
    // Offres
    montant: 'Montant',
    prixDemande: 'Prix demande',
    conditions: 'Conditions',
    conditionsPlaceholder: 'Conditions suspensives, delais...',
    messageAgent: 'Message a l\'agent',
    messagePlaceholder: 'Un mot pour l\'agent...',
    envoyerOffre: 'Envoyer mon offre',
    envoyerContreOffre: 'Envoyer ma contre-offre',
    offreSent: 'Votre offre a ete envoyee avec succes.',
    contreOffreSent: 'Votre contre-offre a ete envoyee avec succes.',
    noOffres: 'Aucune offre pour le moment.',
    faireContreOffre: 'Faire une contre-offre',
    faireOffreTitle: 'Faire une offre en ligne',
    // Feedback
    feedbackTitle: 'Votre avis apres la visite',
    ratingLabel: 'Note globale',
    positifs: 'Points positifs',
    negatifs: 'Points a ameliorer',
    commentaire: 'Commentaire',
    commentairePlaceholder: 'Partagez votre impression...',
    wouldRecommend: 'Recommanderiez-vous ce bien ?',
    envoyerFeedback: 'Envoyer mon avis',
    feedbackSent: 'Merci pour votre avis !',
    tags: {
      luminosite: 'Luminosite', agencement: 'Agencement', quartier: 'Quartier',
      calme: 'Calme', 'etat-general': 'Etat general', jardin: 'Jardin',
      terrasse: 'Terrasse', parking: 'Parking', transports: 'Transports',
      commerces: 'Commerces', bruit: 'Bruit', humidite: 'Humidite',
      travaux: 'Travaux', taille: 'Taille', isolation: 'Isolation', prix: 'Prix',
    } as Record<string, string>,
    // Simulateur
    simApport: 'Apport personnel',
    simDuree: 'Duree',
    simAnnees: 'annees',
    simTaux: 'Taux',
    simRegion: 'Region',
    simResultats: 'Resultats de la simulation',
    simMensualite: 'Mensualite',
    simEmprunt: 'Montant emprunte',
    simFraisNotaire: 'Frais de notaire',
    simDroits: 'Droits d\'enregistrement',
    simInterets: 'Total interets',
    simCoutGlobal: 'Cout global',
    simDisclaimer: 'Simulation indicative. Consultez votre banque pour une offre personnalisee. Droits d\'enregistrement calcules via @saas/proptax.',
    // Comparateur
    noComparables: 'Aucun bien comparable disponible.',
    comparablesTitle: 'Biens comparables',
    sortPrix: 'Trier par prix',
    sortSurface: 'Trier par surface',
    sortPrixM2: 'Trier par prix/m2',
    compType: 'Type',
    compCommune: 'Commune',
    compSurface: 'Surface',
    compChambres: 'Chambres',
    compPrix: 'Prix',
    // Estimation
    estType: 'Type',
    estSurface: 'Surface',
    estChambres: 'Chambres',
    estRapport: 'Rapport d\'estimation',
    estDate: 'Date du calcul',
    estNone: 'Aucune estimation disponible.',
    // Catalogue
    photos: 'photos',
    noPhotos: 'Pas de photo',
    noBiens: 'Aucun bien disponible.',
    biensDisponibles: 'Biens disponibles',
    // Conditions
    condRemplie: 'Remplie',
    condEnCours: 'En cours',
    dateCompromis: 'Date compromis',
    dateActe: 'Date acte prevue',
    // Post-vente / Parrainage
    parrainageTitle: 'Programme de parrainage',
    parrainageDesc: 'Parrainez un proche et beneficiez d\'avantages exclusifs.',
    parrainageNom: 'Nom du filleul',
    parrainageEmail: 'Email du filleul',
    parrainerBtn: 'Parrainer',
    parrainageSent: 'Parrainage enregistre !',
    mesParrainages: 'Mes parrainages',
    statusPending: 'En attente',
    statusConverted: 'Converti',
  },
  landing: {
    skipToContent: 'Aller au contenu principal',
    nav: {
      features: 'Fonctionnalités',
      calculator: 'Calculateur',
      pricing: 'Tarifs',
      contact: 'Contact',
    },
    hero: {
      titlePre: "L'agent immobilier ",
      titleAccent: 'belge',
      titlePost: " mérite mieux qu'un tableur Excel",
      subtitle: 'Gagnez 2h par jour, ne perdez plus aucun mandat. CRM, fiscalité intégrée et IA — tout géré depuis une seule plateforme pour piloter votre activité.',
      cta: 'Demander un accès',
      login: 'Se connecter',
    },
    cta: {
      trial: 'Essai gratuit 14 jours',
      demo: 'Voir la démo',
    },
    painPoint: 'Vous jonglez entre 4 outils, vous oubliez des relances, vous calculez les droits d\'enregistrement sur une feuille volante. On a construit Patrimia pour que ça s\'arrête.',
    features: {
      sectionTitle: 'Tout ce dont un agent belge a besoin',
      aria: {
        title: 'Aria, votre assistante IA',
        description: "Matching acheteurs, rédaction d'annonces, scoring de prix, triage email — Aria automatise les tâches répétitives pour vous concentrer sur vos clients.",
        badgeNew: 'Nouveau',
      },
      proptax: {
        title: 'Fiscalité PropTax',
        description: '7 calculateurs natifs — droits d\'enregistrement, précompte immobilier, indexation loyers. Les 3 régions belges couvertes.',
        badgeBE: 'Exclusif BE',
      },
      crm: {
        title: 'CRM immobilier',
        description: 'Contacts, mandats, pipeline de vente, visites, offres — tout en un.',
      },
      portals: {
        title: 'Portails clients',
        description: 'Vos vendeurs et acheteurs suivent leur dossier en temps réel.',
      },
      livret: {
        title: 'Livret Bien PDF',
        description: 'Générez des brochures professionnelles en un clic.',
      },
      mailbox: {
        title: 'Mailbox Pro',
        description: 'Triage intelligent de vos emails par Aria — leads, dossiers, visites.',
      },
    },
    social: {
      stats: {
        agents: { value: '200+', label: 'Agents utilisateurs' },
        regions: { value: '3', label: 'Régions belges' },
        tools: { value: '12', label: 'Outils IA' },
      },
      testimonial: {
        quote: 'Patrimia m\'a fait gagner 2h par jour sur mes relances.',
        author: 'Sophie M., agent indépendante, Namur',
      },
    },
    wiifm: {
      ariaLabel: 'Ce que Patrimia apporte à chacun',
      sectionTitle: 'Ce que vous y gagnez, vous',
      sectionSubtitle: 'Patrimia simplifie la vie de tous les acteurs d\'une transaction — pas seulement celle de l\'agent.',
      agent: {
        label: 'Agent immobilier',
        intro: 'Concentrez-vous sur vos clients. Aria et PropTax gèrent le reste.',
        benefits: {
          time: { title: '2h gagnées par jour', desc: 'Relances, tri d\'emails, calculs fiscaux — automatisés. Vous revenez aux négociations.' },
          aria: { title: 'IA intégrée (Aria)', desc: 'Matching acheteurs, rédaction d\'annonces, scoring de prix, triage email — en un outil.' },
          proptax: { title: 'Fiscalité PropTax', desc: '7 calculateurs belges : droits d\'enregistrement, précompte, indexation. Les 3 régions.' },
          crm: { title: 'CRM centralisé', desc: 'Contacts, mandats, pipeline, visites — plus de tableur, plus d\'outil éparpillé.' },
          livret: { title: 'Livret bien PDF', desc: 'Brochure professionnelle générée en 1 clic depuis votre fiche mandat.' },
          pipeline: { title: 'Pipeline de vente', desc: 'Kanban visuel : suivez chaque dossier de l\'offre à l\'acte en temps réel.' },
        },
      },
      bailleur: {
        label: 'Propriétaire / Bailleur',
        intro: 'Votre bien, vos locataires, vos revenus — suivis sans avoir à appeler votre agent.',
        benefits: {
          suivi: { title: 'Suivi en temps réel', desc: 'Portail sécurisé : consultez l\'avancement de votre dossier à tout moment, sans rendez-vous.' },
          messages: { title: 'Communication directe', desc: 'Échangez avec votre agent via la messagerie intégrée — historique complet, zéro email perdu.' },
          documents: { title: 'Documents partagés', desc: 'PEB, plans, bail, compromis — accessibles en ligne depuis votre portail.' },
          indexation: { title: 'Indexation calculée', desc: 'Votre agent calcule l\'indexation de votre loyer en quelques secondes via PropTax. Vous recevez le résultat.' },
        },
      },
      locataire: {
        label: 'Locataire',
        intro: 'Fini l\'incertitude. Votre dossier est visible, vos documents sont accessibles, votre loyer est calculé.',
        benefits: {
          portail: { title: 'Portail sécurisé', desc: 'Lien unique envoyé par votre agence. Consultez l\'état de votre dossier locatif sans créer de compte.' },
          messages: { title: 'Messagerie avec l\'agence', desc: 'Posez vos questions directement dans le portail. Fini le téléphone sans réponse ou l\'email perdu.' },
          documents: { title: 'Vos documents en ligne', desc: 'Bail, état des lieux, certificat PEB, règlement — tout est là, téléchargeable à tout moment.' },
          indexation: { title: 'Indexation de loyer transparente', desc: 'Votre agence calcule l\'indexation via Patrimia. Le résultat et le détail vous sont transmis dans le portail.' },
          transparency: { title: 'Zéro surprise', desc: 'Vous voyez où en est votre dossier : en cours, validé, signé. Pas d\'incertitude.' },
        },
        note: 'L\'accès locataire est activé par votre agence — aucune inscription de votre côté.',
      },
    },
    aria: {
      heroLabel: 'Section héro',
      painLabel: 'Pourquoi Patrimia',
      featuresLabel: 'Fonctionnalités',
      wiifmLabel: 'Ce que vous y gagnez',
      socialLabel: 'Preuves sociales',
      calculatorLabel: 'Calculateur fiscal',
      pricingLabel: 'Tarifs',
    },
    calculator: {
      badge: 'Gratuit — sans inscription',
      title: 'Calculez vos droits d\'enregistrement',
      subtitle: 'Simulez en temps réel les frais d\'achat immobilier pour les 3 régions belges. Résultat instantané, 100% conforme à la législation 2026.',
      ariaLabel: 'Calculateur de droits d\'enregistrement',
      labels: {
        purchasePrice: 'Prix d\'achat',
        region: 'Région',
        isOnlyHome: 'Habitation unique',
      },
      regions: {
        wallonie: 'Wallonie',
        flandre: 'Flandre',
        bruxelles: 'Bruxelles',
      },
      results: {
        amount: 'Droits à payer',
        effectiveRate: 'Taux effectif',
        abatement: 'Abattement',
        taxableBase: 'Base taxable',
      },
      cta: 'Accéder aux 7 calculateurs fiscaux',
      disclaimer: 'Calcul indicatif basé sur la législation en vigueur. Consultez votre notaire pour un calcul officiel.',
    },
    mockup: {
      title: 'Patrimia Dashboard',
      mandatsActifs: 'Mandats actifs',
      pipeline: 'Pipeline',
      contacts: 'Contacts',
      visitesWeek: 'Visites/sem.',
      visite: 'Visite',
      offre: 'Offre',
      nego: 'Nego',
      compromis: 'Compromis',
      acte: 'Acte',
    },
    footer: {
      tagline: 'CRM immobilier tout-en-un pour le marché belge',
      linksTitle: 'Produit',
      links: {
        features: { label: 'Fonctionnalités', href: '#features' },
        pricing: { label: 'Tarifs', href: '#pricing' },
        contact: { label: 'Contact', href: 'mailto:contact@patrimia.be' },
      },
      legalTitle: 'Légal',
      legal: {
        mentions: 'Mentions légales',
        privacy: 'Politique de confidentialité',
      },
      copyright: '© 2026 Patrimia — IT-Transform. Tous droits réservés.',
    },
  },
  mailbox: {
    title: 'Mailbox Pro',
    description: 'Triage intelligent de vos emails par Aria — leads, dossiers, visites.',
    inbox: 'Inbox',
    compose: 'Composer',
    triage: 'Triage IA',
    settings: 'Parametres',
    notConfigured: 'Mailbox non configuree. Configurez vos parametres IMAP.',
    noEmails: 'Aucun email.',
    send: 'Envoyer',
    reply: 'Repondre',
    triageAction: 'Trier avec Aria',
    testConnection: 'Tester connexion',
    connectionOk: 'Connexion OK',
    save: 'Enregistrer',
  },
  documents: {
    title: 'Documents',
    description: 'Gerez les documents de vos mandats et generez des livrets PDF.',
    selectMandat: 'Selectionnez un mandat',
    selectPrompt: 'Selectionnez un mandat pour voir ses documents.',
    noMandats: 'Aucun mandat disponible.',
    files: 'Documents',
    noDocs: 'Aucun document pour ce mandat.',
    livret: 'Livret du bien',
    generateLivret: 'Generer un livret',
    noLivrets: 'Aucun livret genere.',
    share: 'Partager',
    download: 'Telecharger',
  },
  admin: {
    title: 'Administration',
    description: 'Gerez votre agence, equipe, commissions et performances.',
    team: 'Equipe',
    commissions: 'Commissions',
    performance: 'Performance',
    export: 'Exporter CSV',
    invite: 'Inviter',
    mandats: 'Mandats agence',
  },
  settings: {
    title: 'Parametres',
    profile: 'Profil',
    ariaConfig: 'Configuration Aria',
    billing: 'Facturation',
    team: 'Equipe',
    integrations: 'Integrations',
  },
  billing: {
    currentPlan: 'Plan actuel',
    nextBilling: 'Prochaine facturation',
    trialEnds: 'Fin de la periode d\'essai',
    cancelScheduled: 'Annulation programmee en fin de periode',
    paymentFailed: 'Le dernier paiement a echoue. Veuillez mettre a jour votre moyen de paiement.',
    seats: 'Postes inclus',
    manageSubscription: 'Gerer mon abonnement',
    addons: 'Modules complementaires',
    addonActive: 'Actif',
    addonAdd: 'Ajouter',
    free: 'Gratuit',
    invoices: 'Historique des factures',
    statuses: {
      active: 'Actif',
      trialing: 'Essai',
      past_due: 'Paiement en retard',
      canceled: 'Annule',
      none: 'Aucun',
    },
    // Pricing page
    pricingTitle: 'Tarifs simples et transparents',
    pricingSubtitle: 'Essai gratuit 14 jours sur tous les plans. Sans engagement.',
    popular: 'Populaire',
    contactUs: 'Nous contacter',
    startTrial: 'Essai gratuit 14 jours',
    plans: {
      solo: 'Solo',
      pro: 'Pro',
      agency: 'Agence',
      enterprise: 'Enterprise',
    },
    features: {
      crm: 'CRM immobilier complet',
      aria_basic: 'Aria IA (20 req/jour)',
      aria_full: 'Aria IA illimite',
      proptax: 'Calculateurs fiscaux',
      portal: 'Portail client',
      mailbox: 'Messagerie intelligente',
      immoweb: 'Publication Immoweb',
      livret: 'Livret du bien PDF',
      dashboard: 'Dashboard consolide',
      commissions: 'Gestion commissions',
      seats_1: '1 agent inclus',
      seats_3: '3 agents inclus',
      seats_10: '10 agents inclus',
      seats_unlimited: 'Agents illimites',
      all: 'Toutes les fonctionnalites',
      sso: 'SSO (Azure AD / Google)',
      api: 'Acces API',
      account_manager: 'Account manager dedie',
    },
    addonsTitle: 'Modules complementaires',
    addonNames: {
      proprio: 'Patrimia Proprio',
      syndic: 'Patrimia Syndic',
      invest: 'Patrimia Invest',
      budget: 'Patrimia Budget',
      notaire: 'Patrimia Notaire',
    },
  },
  // ── Proprio Phase 2 ──
  proprio: {
    biens: {
      title: 'Mes biens',
      subtitle: 'Gerez vos biens et baux locatifs',
      addBail: 'Ajouter un bail',
      empty: 'Aucun bien enregistre. Ajoutez votre premier bail !',
    },
    bail: {
      tabInfo: 'Informations',
      tabDocuments: 'Documents',
      tabIndexation: 'Indexation',
      tabQuittances: 'Quittances',
      tabEdl: 'Etat des lieux',
      tabSignalements: 'Signalements',
      sectionBien: 'Le bien',
      sectionLocataire: 'Locataire',
      sectionFinances: 'Conditions financieres',
      sectionBail: 'Details du bail',
    },
    loyers: {
      title: 'Mes loyers',
      subtitle: 'Suivi des paiements et quittances',
      markPaid: 'Marquer paye',
      sendReceipt: 'Envoyer quittance',
      downloadPdf: 'Telecharger PDF',
    },
    edl: {
      title: 'Etat des lieux',
      entree: 'Entree',
      sortie: 'Sortie',
      addPiece: 'Ajouter une piece',
      sign: 'Signer',
      generatePdf: 'Generer PDF',
    },
    signalements: {
      title: 'Signalements',
      new: 'Nouveau signalement',
      analyzeAria: 'Analyser avec Aria',
    },
    indexation: {
      title: 'Indexation',
      simulate: 'Simuler',
      confirm: 'Confirmer l\'indexation',
      history: 'Historique',
    },
    dashboard: {
      title: 'Ma situation',
      biensActifs: 'Biens actifs',
      loyersMensuels: 'Loyers mensuels',
      impayes: 'Impayes',
      prochaineAction: 'Prochaine action',
    },
    nav: {
      mesBiens: 'Mes biens',
      mesLoyers: 'Mes loyers',
      mesLocataires: 'Mes locataires',
      edl: 'États des lieux',
      indexation: 'Indexation',
      signalements: 'Signalements',
      preavis: 'Préavis',
      portail: 'Portail locataire',
      aria: 'Aria Proprio',
      dashboard: 'Ma situation',
    },
  },
  // ── Budget Finance ──
  budgetFinance: {
    nav: {
      title: 'Budget Finance',
    },
    tabs: {
      synthese: 'Synthese',
      perso: 'Perso',
      pro: 'Pro',
      patrimoine: 'Patrimoine',
      transactions: 'Transactions',
      reconciliation: 'Reconciliation',
      aria: 'Aria',
    },
    aria: {
      title: 'Aria — Assistant Budget',
      subtitle: 'Assistant finances personnelles & professionnelles',
      quickPrompts: 'Actions rapides',
      tools: 'Outils disponibles',
      disclaimer: 'Ces projections sont indicatives et ne constituent pas un conseil financier.',
    },
    kpi: {
      revenusMensuels: 'Revenus mensuels',
      chargesMensuelles: 'Charges mensuelles',
      epargneMensuelle: 'Epargne mensuelle',
      patrimoineNet: 'Patrimoine net',
      investissements: 'Investissements',
      dettesRestantes: 'Dettes restantes',
      mrrPro: 'MRR Pro',
      arrPro: 'ARR Pro',
      tauxImpayes: 'Taux impayes',
    },
    trends: {
      moisCourant: 'Ce mois',
      vsPrev: 'vs prec.',
      ytd: 'YTD',
    },
    fields: {
      nom: 'Nom',
      categorie: 'Categorie',
      montant: 'Montant',
      frequence: 'Frequence',
      type: 'Type',
      statut: 'Statut',
      date: 'Date',
      description: 'Description',
    },
    actions: {
      ajouter: 'Ajouter',
      modifier: 'Modifier',
      supprimer: 'Supprimer',
      enregistrer: 'Enregistrer',
      annuler: 'Annuler',
      exporter: 'Exporter',
    },
    categories: {
      logement: 'Logement',
      transport: 'Transport',
      alimentation: 'Alimentation',
      sante: 'Sante',
      loisirs: 'Loisirs',
      education: 'Education',
      abonnements: 'Abonnements',
      impots: 'Impots',
      assurances: 'Assurances',
      epargne: 'Epargne',
      investissement: 'Investissement',
      divers: 'Divers',
      salaire: 'Salaire',
      freelance: 'Freelance',
      locatif: 'Revenus locatifs',
      dividendes: 'Dividendes',
      allocations: 'Allocations',
      autre: 'Autre',
    },
    frequences: {
      mensuel: 'Mensuel',
      trimestriel: 'Trimestriel',
      semestriel: 'Semestriel',
      annuel: 'Annuel',
      ponctuel: 'Ponctuel',
      hebdomadaire: 'Hebdomadaire',
    },
    synthese: {
      title: 'Budget — Synthese',
      subtitle: 'Vue d\'ensemble de vos finances personnelles et professionnelles',
      kpiSection: 'Indicateurs cles',
      repartitionCharges: 'Repartition des charges',
      repartitionChargeSub: 'Le graphique donut apparaitra lorsque des charges seront enregistrees',
      analyseAria: 'Analyse Aria',
      analyseAriaSub: 'Aria analysera vos finances et proposera des optimisations',
    },
    perso: {
      title: 'Budget — Perso',
      subtitle: 'Charges personnelles et revenus',
      chargesTitle: 'Charges personnelles',
      revenusTitle: 'Revenus',
      emptyCharges: 'Aucune charge personnelle',
      emptyChargesSub: 'Ajoutez vos charges mensuelles pour suivre votre budget',
      emptyRevenus: 'Aucun revenu enregistre',
      emptyRevenusSub: 'Ajoutez vos sources de revenus',
    },
    pro: {
      title: 'Budget — Pro',
      subtitle: 'Charges professionnelles et revenus d\'activite',
      chargesTitle: 'Charges professionnelles',
      revenusTitle: 'Revenus professionnels',
      emptyCharges: 'Aucune charge professionnelle',
      emptyChargesSub: 'Ajoutez vos charges professionnelles recurrentes',
      emptyRevenus: 'Aucun revenu professionnel',
      emptyRevenusSub: 'Ajoutez vos sources de revenus professionnels',
    },
    patrimoine: {
      title: 'Budget — Patrimoine',
      subtitle: 'Ventilation de votre patrimoine net',
      actifs: 'Actifs',
      engagements: 'Engagements',
      emptyTitle: 'Aucune donnee patrimoine',
      emptySub: 'Les categories de patrimoine apparaitront une fois les comptes configures',
      categoriesLabels: {
        liquidites: 'Liquidites',
        epargne: 'Epargne',
        investissements: 'Investissements',
        pension: 'Pension',
        creances: 'Creances',
        engagements: 'Engagements',
      },
    },
    transactions: {
      title: 'Transactions',
      subtitle: 'Suivi des mouvements financiers',
      emptyTitle: 'Aucune transaction',
      emptySub: 'Connectez votre banque via GoCardless ou importez un fichier CODA/CSV pour demarrer',
      connectBtn: 'Connecter banque',
      importBtn: 'Importer',
      importCodaBtn: 'Fichier CODA',
      importCsvBtn: 'Fichier CSV',
      syncBtn: 'Synchroniser',
      syncSuccess: '{imported} transactions importees, {duplicates} doublons ignores',
      allComptes: 'Tous les comptes',
      allStatuts: 'Tous les statuts',
      allMois: 'Tous les mois',
      compte: 'Compte',
      sourceLabel: 'Source',
      statuts: {
        importee: 'Importee',
        rapprochee: 'Rapprochee',
        validee: 'Validee',
        orpheline: 'Orpheline',
      },
      // Import modal
      importCodaTitle: 'Importer un fichier CODA',
      importCsvTitle: 'Importer un fichier CSV',
      importCompte: 'Compte de destination',
      importSelectCompte: 'Selectionner un compte',
      importFile: 'Fichier',
      importPaste: 'Ou coller le contenu',
      importCodaPlaceholder: 'Collez le contenu de votre fichier CODA ici...',
      importCsvPlaceholder: 'Collez le contenu de votre fichier CSV ici...',
      importDoBtn: 'Importer',
      importClose: 'Fermer',
      importSuccess: '{imported} transactions importees, {skipped} doublons ignores',
      importMoreErrors: 'erreurs supplementaires',
      importError: 'Erreur lors de l\'import',
      gocardless: {
        connectTitle: 'Connexion bancaire',
        connectSub: 'Selectionnez votre banque pour connecter votre compte via PSD2',
        institutions: 'Banques disponibles',
        syncing: 'Synchronisation en cours...',
        syncDone: 'Synchronisation terminee',
      },
    },
    reconciliation: {
      title: 'Reconciliation',
      subtitle: 'Rapprochement bancaire automatise par IA',
      runBtn: 'Lancer la reconciliation',
      running: 'Analyse en cours...',
      statsAuto: 'Auto-rapprochees',
      statsProposed: 'A valider',
      statsOrphaned: 'Orphelines',
      proposedTitle: 'Propositions de rapprochement',
      matchLabel: 'Correspondance proposee',
      confidenceLabel: 'Confiance',
      internalTransfer: 'Virement interne',
      acceptBtn: 'Accepter',
      rejectBtn: 'Rejeter',
      emptyTitle: 'Aucune proposition en attente',
      emptySub: 'Lancez une reconciliation pour analyser vos transactions non rapprochees',
      resultSuccess: 'Reconciliation terminee',
      resultDetail: '{auto} auto-rapprochees, {proposed} a valider, {orphaned} orphelines',
      highConfidence: 'Confiance elevee',
      mediumConfidence: 'Confiance moyenne',
      lowConfidence: 'Confiance faible',
    },
  },
  // ── Calendar (F22) ──
  calendar: {
    title: 'Agenda',
    subtitle: 'Planifiez vos visites, rendez-vous et echeances',
    newEvent: 'Nouvel evenement',
    upcoming: 'Prochains evenements',
    noEvents: 'Aucun evenement a venir',
    types: {
      visite: 'Visite',
      rdv: 'Rendez-vous',
      compromis: 'Compromis',
      acte: 'Acte',
      relance: 'Relance',
      ag: 'AG',
      autre: 'Autre',
    } as Record<string, string>,
    fields: {
      title: 'Titre',
      type: 'Type',
      start: 'Debut',
      end: 'Fin',
      location: 'Lieu',
      notes: 'Notes',
    },
    status: {
      confirmed: 'Confirme',
      tentative: 'Provisoire',
      cancelled: 'Annule',
    },
  },
  // ── Tasks Eisenhower (F17) ──
  tasks: {
    title: 'Taches',
    subtitle: 'Matrice Eisenhower — priorisez vos actions',
    newTask: 'Nouvelle tache',
    ariaSuggests: 'Aria suggere',
    emptyQuadrant: 'Aucune tache',
    quadrants: {
      'urgent-important': 'Urgent + Important',
      'not-urgent-important': 'Important',
      'urgent-not-important': 'Urgent',
      'not-urgent-not-important': 'A deleguer / eliminer',
    } as Record<string, string>,
    fields: {
      title: 'Titre',
      description: 'Description',
      quadrant: 'Quadrant',
      priority: 'Priorite',
      dueDate: 'Echeance',
      tags: 'Tags',
    },
    priority: {
      high: 'Haute',
      medium: 'Moyenne',
      low: 'Basse',
    },
    status: {
      todo: 'A faire',
      in_progress: 'En cours',
      done: 'Termine',
      cancelled: 'Annule',
    },
  },
  // ── Publication (F9) ──
  publication: {
    title: 'Publications',
    subtitle: 'Gerez vos annonces sur les portails immobiliers',
    publish: 'Publier',
    unpublish: 'Depublier',
    syncStats: 'Synchroniser',
    portals: {
      immoweb: 'Immoweb',
      immovlan: 'Immovlan',
      zimmo: 'Zimmo',
      'logic-immo': 'Logic-Immo',
      facebook: 'Facebook',
    } as Record<string, string>,
    status: {
      draft: 'Brouillon',
      published: 'Publie',
      paused: 'En pause',
      expired: 'Expire',
      error: 'Erreur',
    },
    stats: {
      views: 'Vues',
      contacts: 'Contacts',
      favorites: 'Favoris',
    },
    lastSync: 'Derniere synchronisation',
    noPublications: 'Aucune publication',
    bulkPublish: 'Publier sur plusieurs portails',
  },
  // ── Templates communication ──
  templates: {
    title: 'Templates communication',
    subtitle: 'Gerez vos modeles email, SMS et courrier pour l\'immobilier.',
    create: 'Nouveau template',
    seedDefaults: 'Charger les templates',
    allCategories: 'Toutes les categories',
    allChannels: 'Tous les canaux',
    preview: 'Apercu',
    useTemplate: 'Utiliser le template',
    empty: 'Aucun template',
    emptySub: 'Chargez les templates par defaut ou creez le votre.',
    categories: {
      prospection: 'Prospection',
      mandat: 'Mandat',
      visite: 'Visite',
      offre: 'Offre',
      compromis: 'Compromis',
      acte: 'Acte',
      locatif: 'Locatif',
      syndic: 'Syndic',
      admin: 'Admin',
    },
    channels: {
      email: 'Email',
      sms: 'SMS',
      courrier: 'Courrier',
    },
  },
  // ── Integrations ──
  integrations: {
    title: 'Integrations',
    subtitle: 'Connectez vos outils et services externes pour enrichir Patrimia.',
    connect: 'Connecter',
    disconnect: 'Deconnecter',
    statusConnected: 'Connecte',
    statusDisconnected: 'Non connecte',
    statusError: 'Erreur',
    providers: {
      billtobox: 'BillToBox',
      izimi: 'IZIMI',
      mapbox: 'Mapbox',
      immoweb: 'Immoweb',
      notaire_be: 'Notaire.be',
    },
  },
  permissions: {
    insufficientPermissions: 'Permissions insuffisantes',
    noAccess: 'Vous n\'avez pas acces a cette ressource',
    readOnly: 'Acces en lecture seule',
    supportReadOnly: 'Le role Support ne permet que la lecture',
    supportAccessDisabled: 'L\'acces support n\'est pas active pour ce tenant',
    supportBadge: 'Support',
    platformAdmin: 'Admin Plateforme',
    requiresRole: 'Cette action necessite le role : {role}',
    contactOwnOnly: 'Vous ne pouvez voir que vos propres contacts',
    cannotCreateMandat: 'Vous n\'etes pas autorise a creer des mandats',
    cannotModifyTransaction: 'Vous n\'etes pas autorise a modifier les transactions',
    impersonationActive: 'Impersonation active',
    impersonationBy: 'Connecte en tant que {name} par {admin}',
    roles: {
      AGENT: 'Agent',
      AGENCY_ADMIN: 'Administrateur Agence',
      COLLABORATOR: 'Collaborateur',
      CLIENT: 'Client',
      SUPPORT: 'Support',
      PLATFORM_ADMIN: 'Administrateur Plateforme',
    },
  },
  // ── Phase 5 — Invest ──
  invest: {
    title: 'Investissements',
    nav: {
      title: 'Navigation investissement',
    },
    tabs: {
      portefeuille: 'Portefeuille',
      simulateurLocatif: 'Simulateur locatif',
      simulateurCredit: 'Simulateur credit',
      benchmark: 'Benchmark',
      fiscal: 'Fiscal',
    },
    simulateurLocatif: {
      title: 'Simulateur de rendement locatif',
      inputsTitle: 'Parametres du bien',
      prixAchat: 'Prix d\'achat',
      fraisNotaire: 'Frais de notaire',
      travaux: 'Travaux',
      loyerMensuel: 'Loyer mensuel',
      chargesMensuelles: 'Charges mensuelles',
      taxeFonciere: 'Taxe fonciere',
      assurancePNO: 'Assurance PNO',
      vacanceLocative: 'Vacance locative',
      gestionLocative: 'Gestion locative',
      tauxImposition: 'Taux d\'imposition',
      prixTotal: 'Prix total',
      rendementBrut: 'Rendement brut',
      rendementNet: 'Rendement net',
      rendementNetNet: 'Rendement net-net',
      cashflowMensuel: 'Cashflow mensuel',
      tri10: 'TRI 10 ans',
      tri15: 'TRI 15 ans',
      tri20: 'TRI 20 ans',
      chartTitle: 'Evolution patrimoine et cashflow sur 20 ans',
      chartPatrimoine: 'Patrimoine',
      chartCashflow: 'Cashflow cumule',
      chartXLabel: 'Annees',
      save: 'Sauvegarder la simulation',
      euro: '\u20ac',
      euroMois: '\u20ac/mois',
      euroAn: '\u20ac/an',
    },
    simulateurCredit: {
      title: 'Simulateur de credit hypothecaire',
      inputsTitle: 'Parametres du credit',
      montantEmprunte: 'Montant emprunte',
      taux: 'Taux d\'interet',
      duree: 'Duree',
      typeCredit: 'Type de credit',
      fixe: 'Taux fixe',
      variable: 'Taux variable',
      apport: 'Apport personnel',
      fraisDossier: 'Frais de dossier',
      mensualiteLabel: 'Mensualite',
      coutTotal: 'Cout total du credit',
      coutInterets: 'Cout des interets',
      chartTitle: 'Repartition capital / interets par annee',
      chartXLabel: 'Annees',
      voirTableau: 'Voir le tableau d\'amortissement',
      masquerTableau: 'Masquer le tableau d\'amortissement',
      exportCSV: 'Exporter CSV',
      save: 'Sauvegarder',
      euro: '\u20ac',
      euroMois: '\u20ac/mois',
      annees: 'ans',
      csvMois: 'Mois',
      csvMensualite: 'Mensualite',
      csvCapital: 'Capital',
      csvInterets: 'Interets',
      csvRestant: 'Restant du',
    },
    benchmark: {
      title: 'Benchmark marche',
      chartTitle: 'Performance portefeuille vs indices (36 mois)',
      tableTitle: 'Comparaison detaillee',
      portfolio: 'Mon portefeuille',
      immoBelge: 'Immo Belge',
      rendementTotal: 'Rendement total',
      rendementAnnualise: 'Rendement annualise',
      volatilite: 'Volatilite',
      sharpe: 'Ratio Sharpe',
      indice: 'Indice',
    },
    fiscal: {
      title: 'Export fiscal',
      selectYear: 'Selectionner l\'annee',
      exportPDF: 'Exporter PDF',
      printTitle: 'Resume fiscal — Patrimia Invest',
      printDate: 'Genere le',
      noData: 'Aucune donnee fiscale pour cette annee. Ajoutez des projets acquis pour generer le resume.',
      euro: '\u20ac',
      totalRevenus: 'Total revenus',
      totalCharges: 'Total charges',
      baseImposable: 'Base imposable',
      estimationImpot: 'Estimation impot',
      sectionRevenus: 'Revenus',
      loyersBruts: 'Loyers bruts',
      revenusLocatifsNets: 'Revenus locatifs nets',
      revenusMobiliers: 'Revenus mobiliers',
      sectionCharges: 'Charges deductibles',
      chargesDeductibles: 'Charges courantes',
      taxeFonciere: 'Taxe fonciere / Precompte immobilier',
      interetsEmprunt: 'Interets d\'emprunt',
      amortissements: 'Amortissements',
      travaux: 'Travaux',
      assurances: 'Assurances',
      fraisGestion: 'Frais de gestion',
      sectionBelgique: 'Specificites belges',
      rcIndexe: 'Revenu cadastral indexe',
      precompteImmobilier: 'Precompte immobilier',
      precompteMobilier: 'Precompte mobilier (30%)',
      additionelsRC: 'Additionnels communaux sur RC',
      sectionPlusValues: 'Plus-values',
      courtTerme: 'Plus-values court terme (< 5 ans)',
      longTerme: 'Plus-values long terme (> 5 ans)',
    },
  },
  // ── UX terrain (F23-F32) ──
  onboarding: {
    stepWelcome: 'Bienvenue',
    stepProfile: 'Profil agence',
    stepImport: 'Import contacts',
    stepMandat: 'Premier mandat',
    stepSummary: 'Resume',
    welcomeTitle: 'Bienvenue sur Patrimia',
    welcomeDesc: 'Configurons votre espace en quelques etapes. Vous pourrez tout modifier plus tard dans les parametres.',
    profileTitle: 'Profil de votre agence',
    agencyName: 'Nom de l\'agence',
    agencyPhone: 'Telephone',
    agencyAddress: 'Adresse',
    importTitle: 'Importez vos contacts',
    importDesc: 'Importez un fichier CSV avec vos contacts existants. Colonnes attendues : nom, prenom, email, telephone, type.',
    importChoose: 'Choisir un fichier CSV',
    importOptional: 'Optionnel — vous pourrez importer plus tard',
    mandatTitle: 'Votre premier mandat',
    mandatDesc: 'Ajoutez un premier bien pour decouvrir le workflow Patrimia.',
    mandatAddressLabel: 'Adresse du bien',
    mandatPriceLabel: 'Prix demande',
    mandatOptional: 'Optionnel — vous pourrez creer des mandats plus tard',
    summaryTitle: 'Tout est pret !',
    summaryDesc: 'Votre espace Patrimia est configure. Vous pouvez commencer a travailler.',
    finish: 'Commencer',
  },
  glossaire: {
    title: 'Glossaire immobilier',
    subtitle: 'Termes et definitions du marche immobilier belge',
    searchPlaceholder: 'Rechercher un terme...',
    terms: 'termes',
  },
  quickNotes: {
    title: 'Notes rapides',
    placeholder: 'Ecrire une note...',
    add: 'Ajouter',
    empty: 'Aucune note',
    delete: 'Supprimer la note',
  },
  nps: {
    title: 'Votre avis compte',
    question: 'Recommanderiez-vous Patrimia a un collegue ?',
    labelLow: 'Pas du tout',
    labelHigh: 'Absolument',
    commentPlaceholder: 'Un commentaire ? (optionnel)',
    submit: 'Envoyer',
    thanks: 'Merci pour votre retour !',
  },
  shortcuts: {
    title: 'Raccourcis clavier',
    search: 'Recherche globale',
    newContact: 'Nouveau contact',
    newMandat: 'Nouveau mandat',
    help: 'Afficher les raccourcis',
  },
  offline: {
    message: 'Vous etes hors ligne',
  },
  // ── F33 — Comparaison mandats ──
  compare: {
    title: 'Comparer des biens',
    subtitle: 'Selectionnez jusqu\'a 3 mandats a comparer cote a cote.',
    exportPdf: 'Exporter PDF',
    selectHint: 'Selectionner un bien',
    selectAtLeast2: 'Selectionnez au moins 2 biens',
    prix: 'Prix demande',
    surface: 'Surface',
    prixM2: 'Prix / m²',
    pieces: 'Pieces',
    chambres: 'Chambres',
    localisation: 'Localisation',
    revCadastral: 'Revenu cadastral',
    charges: 'Charges',
    epc: 'Score PEB',
    ariaScore: 'Score Aria',
  },
  // ── F35 — Droits d'enregistrement ──
  droitsEnreg: {
    pageTitle: 'Droits d\'enregistrement',
    pageSubtitle: 'Calculez les frais d\'acquisition pour un bien immobilier en Belgique.',
    title: 'Calculateur de droits d\'enregistrement',
    subtitle: 'Estimation selon la region et le profil de l\'acheteur',
    prix: 'Prix d\'acquisition',
    region: 'Region',
    buyerType: 'Profil acheteur',
    premierAchat: 'Premier achat',
    investisseur: 'Investisseur',
    tvaLabel: 'Achat neuf soumis a la TVA',
    result: 'Droits d\'enregistrement estimés',
    disclaimer: 'Estimation indicative — consultez un notaire pour un calcul definitif.',
  },
  // ── F36 — Signature electronique ──
  signature: {
    title: 'Signature electronique',
    subtitle: 'Signez ce document en tracant votre signature dans le cadre ci-dessous.',
    errLoad: 'Impossible de charger le document a signer.',
    errGeneric: 'Une erreur est survenue.',
    errNetwork: 'Erreur reseau — verifiez votre connexion.',
    portal: 'Portail client',
    legalNotice: 'En signant, vous acceptez les conditions et certifiez avoir lu le document.',
    drawLabel: 'Tracez votre signature ici',
    poweredBy: 'Signature securisee via Patrimia',
    alreadySigned: 'Ce document a deja ete signe.',
    placeholderText: 'Signez ici',
    clear: 'Effacer',
    submit: 'Je signe',
  },
  // ── F37 — Presentation bien ──
  presentation: {
    label: 'Presentation',
    exitFullscreen: 'Quitter le plein ecran',
    enterFullscreen: 'Plein ecran',
    prevPhoto: 'Photo precedente',
    nextPhoto: 'Photo suivante',
    qrLabel: 'Scanner pour voir en ligne',
    keyboardHintPhotos: '← → photos',
    keyboardHintExit: 'Echap quitter',
  },
  aml: {
    tabTitle: 'Conformite AML',
    registreTitle: 'Registre AML',
    procedureTitle: 'Procedure interne AML',
    trainingsTitle: 'Formations AML',
    identification: 'Identification',
    riskAssessment: 'Evaluation du risque',
    originOfFunds: 'Origine des fonds',
    validation: 'Validation',
    status: 'Statut',
    statusIncomplete: 'Incomplet',
    statusPendingReview: 'En attente de validation',
    statusPending_review: 'En attente de validation',
    statusApproved: 'Approuve',
    statusRejected: 'Rejete',
    statusCtifDeclared: 'Declare CTIF',
    statusCtif_declared: 'Declare CTIF',
    statusBlocked: 'Bloque',
    riskLevel: 'Niveau de risque',
    riskLow: 'Faible',
    riskMedium: 'Moyen',
    riskHigh: 'Eleve',
    client: 'Client',
    amount: 'Montant',
    date: 'Date',
    actions: 'Actions',
    approveKyc: 'Valider',
    rejectKyc: 'Rejeter',
    declareCtif: 'Declarer a la CTIF',
    createDossier: 'Creer le dossier KYC',
    noDossier: 'Aucun dossier KYC pour cette transaction',
    notIdentified: 'Non identifie',
    missingItems: 'Elements manquants',
    riskTriggers: 'Facteurs de risque',
    exportCsv: 'Exporter CSV',
    rejectReasonPrompt: 'Motif du rejet (min 3 caracteres) :',
    kycRequired: 'Dossier KYC a completer pour {clientName}',
    kycBlocking: 'Le compromis ne peut pas etre signe sans KYC approuve',
    eddRequired: 'Vigilance renforcee requise (EDD)',
    procedureOverdue: 'Procedure AML : revision en retard',
    trainingOverdue: 'Formation AML annuelle manquante',
    ariaDisclaimer: 'Aria fournit une assistance — la responsabilite AML reste celle de l\'agent agree IPI.',
    dashboardCompliant: 'Dossiers conformes',
    dashboardPending: 'En attente',
    dashboardOverdue: 'Incomplets > 48h',
    procedureUpToDate: 'Procedure : a jour',
    procedureMissing: 'Procedure : absente',
    procedureOverdueShort: 'Procedure : revision en retard',
    nextReview: 'Prochaine revision',
    viewRegistre: 'Voir le registre AML',
  },
  notifications: {
    title: 'Notifications',
    label: 'Notifications',
    panelLabel: 'Panneau de notifications',
    unread: 'non lue',
    markAllRead: 'Tout marquer comme lu',
    empty: 'Aucune notification',
  },
  userMenu: {
    myAccount: 'Mon compte',
    settings: 'Paramètres',
    logout: 'Déconnexion',
  },
  // ── P1-02 : SyndicPage i18n ──
  syndicPage: {
    title: 'Syndic — Copropriete',
    tabs: { copros: 'Coproprietes', lots: 'Lots', appels: 'Appels de fonds', dashboard: 'Dashboard' },
    newCopro: 'Nouvelle copropriete',
    fields: {
      nom: 'Nom de la copropriete',
      adresse: 'Adresse',
      codePostal: 'Code postal',
      commune: 'Commune',
      milliemes: 'Milliemes total',
    },
    create: 'Creer',
    emptyCopro: 'Aucune copropriete',
    emptyCoproSub: 'Utilisez le bouton ci-dessus pour en creer une.',
    addLot: 'Ajouter un lot',
    lotFields: {
      numero: 'Numero (A01)',
      etage: 'Etage',
      quotites: 'Quotites (milliemes)',
      nomProprio: 'Nom proprietaire',
      emailOptional: 'Email (optionnel)',
    },
    add: 'Ajouter',
    emptyLots: 'Aucun lot',
    emptyLotsSub: 'Utilisez le bouton ci-dessus pour ajouter les lots de la copropriete.',
    lotPrefix: 'Lot',
    milliemesLabel: 'milliemes',
    newAppel: 'Nouvel appel de fonds',
    appelFields: {
      label: 'Libelle',
      trimestre: 'Trimestre (2026-Q1)',
      montantTotal: 'Montant total',
    },
    createAppel: 'Creer l\'appel',
    emptyAppels: 'Aucun appel de fonds',
    emptyAppelsSub: 'Utilisez le bouton ci-dessus pour en creer un.',
    paye: 'Paye',
    marquerPaye: 'Marquer paye',
    dashLabels: {
      lots: 'Lots',
      totalAppels: 'Total appels',
      totalPaye: 'Total paye',
      tauxRecouvrement: 'Taux recouvrement',
    },
    confirmDelete: 'Etes-vous sur de vouloir supprimer cet element ?',
    accentColor: 'var(--color-primary)',
  },
  // ── P1-02 : NotairePage i18n ──
  notairePage: {
    title: 'Outils Notaire',
    tabs: { calculer: 'Calculateur frais', estimations: 'Mes estimations', checklists: 'Checklists' },
    calcTitle: 'Frais de notaire en Belgique',
    fields: {
      prixVente: 'Prix de vente',
      region: 'Region',
      habitationPropre: 'Habitation propre et unique',
      premierAchat: 'Premier achat',
    },
    calculer: 'Calculer',
    results: {
      droits: 'Droits d\'enregistrement',
      honoraires: 'Honoraires notaire',
      divers: 'Frais divers',
      total: 'Total frais',
      tauxEffectif: 'Taux effectif',
    },
    sauvegarder: 'Sauvegarder',
    prixTotalEstime: 'Prix total estime',
    emptyEstimations: 'Aucune estimation',
    emptyEstimationsSub: 'Utilisez le calculateur pour en creer une.',
    checklistAchat: 'Checklist achat',
    checklistVente: 'Checklist vente',
    emptyChecklists: 'Aucune checklist',
    emptyChecklistsSub: 'Utilisez les boutons ci-dessus pour en creer une et suivre vos demarches.',
    confirmDelete: 'Etes-vous sur de vouloir supprimer cet element ?',
  },
  // ── P1-02 : BudgetPage (charges locatives) i18n ──
  budgetChargePage: {
    title: 'Budget & Charges',
    emptyBail: 'Aucun bail actif',
    emptyBailSub: 'Creez un bail dans Proprio pour gerer le budget.',
    tabs: { charges: 'Charges', provisions: 'Provisions', decomptes: 'Decomptes', resume: 'Resume' },
    addCharge: 'Ajouter une charge',
    fields: {
      label: 'Libelle',
      montant: 'Montant',
      mois: 'Mois',
      dateDebut: 'Date debut',
      dateFin: 'Date fin',
    },
    save: 'Enregistrer',
    emptyCharges: 'Aucune charge enregistree',
    emptyChargesSub: 'Utilisez le bouton ci-dessus pour en ajouter une.',
    newProvision: 'Nouvelle provision',
    emptyProvisions: 'Aucune provision',
    emptyProvisionsSub: 'Utilisez le bouton ci-dessus pour en creer une.',
    payee: 'Payee',
    marquerPayee: 'Marquer payee',
    genererDecompte: 'Generer un decompte',
    generer: 'Generer',
    emptyDecomptes: 'Aucun decompte',
    emptyDecomptesSub: 'Utilisez le bouton ci-dessus pour en generer un.',
    chargesReelles: 'Charges reelles',
    provisionsLabel: 'Provisions',
    solde: 'Solde',
    resumeLabels: {
      chargesAnnuelles: 'Charges annuelles',
      provisionsMensuelles: 'Provisions mensuelles',
      provisionsPaid: 'Provisions payees',
      balance: 'Balance',
    },
    repartitionCategorie: 'Repartition par categorie',
    confirmDelete: 'Etes-vous sur de vouloir supprimer cet element ?',
  },
  // ── P1-03 : BudgetAriaPage i18n ──
  budgetAria: {
    headerSub: 'Assistant finances personnelles & professionnelles',
    placeholder: 'Posez votre question a Aria Budget...',
    greeting: 'Bonjour, je suis {name}.',
    greetingSub: 'Posez-moi vos questions sur votre budget, vos investissements ou votre patrimoine.',
    quickActions: 'Actions rapides',
    toolsTitle: 'Outils disponibles',
    tools: {
      synthese: 'Synthese mensuelle',
      charges: 'Analyse des charges',
      dettes: 'Situation dettes & credits',
      portefeuille: 'Portefeuille investissements',
      patrimoineNet: 'Patrimoine net',
      projectionEpargne: 'Projection epargne',
      nonReconciliees: 'Transactions non reconciliees',
    },
    inputLabel: 'Message a Aria Budget',
    sendLabel: 'Envoyer le message',
    errConnection: 'Erreur de connexion avec Aria.',
  },
  // ── P1-04 : SettingsPage i18n ──
  settingsPage: {
    onboarding: 'Onboarding',
    apiKeys: 'Cles API',
    currentPlan: 'Abonnement actuel',
    displayName: 'Nom affiche',
    phone: 'Telephone',
    agency: 'Agence',
    bio: 'Bio',
    language: 'Langue',
    langFr: 'Francais',
    langNl: 'Nederlands',
    langDe: 'Deutsch',
    aiNameLabel: 'Nom de l\'assistant IA',
    aiNameHint: 'Personnalisez le nom affiche dans le chat IA (ex: Aria, Richard, Alex...)',
    saving: 'Sauvegarde...',
    save: 'Enregistrer',
    autoSuggestions: 'Suggestions automatiques Aria',
    triageEmail: 'Triage email automatique',
    confidenceThreshold: 'Seuil de confiance (%)',
    maxDailyRequests: 'Requetes max / jour',
    apiKeyWarning: 'Les cles API permettent un acces programmatique a vos donnees. Elles ont les memes droits qu\'un AGENT sur votre tenant. Ne partagez jamais une cle — revoquez-la si compromise.',
    createNewKey: 'Creer une nouvelle cle',
    keyNamePlaceholder: 'Nom de la cle (ex: Richard, Zapier...)',
    create: 'Creer',
    keyCreated: 'Cle creee — copiez-la maintenant, elle ne sera plus affichee',
    copy: 'Copier',
    copied: 'Copie !',
    keyCopied: 'J\'ai copie ma cle',
    activeKeys: 'Cles actives',
    loadingKeys: 'Chargement...',
    noKeys: 'Aucune cle API.',
    createdOn: 'Creee le',
    lastUsed: 'Derniere utilisation',
    expiresOn: 'Expire le',
    revokeConfirm: 'Revoquer cette cle ? Cette action est irreversible.',
    onboardingComplete: 'Onboarding termine ! Vous avez configure votre compte avec succes.',
    steps: {
      profile: 'Completer votre profil',
      firstMandat: 'Creer votre premier mandat',
      inviteTeam: 'Inviter votre equipe',
      configAria: 'Configurer Aria IA',
      configMailbox: 'Connecter votre messagerie',
    },
    markDone: 'Marquer fait',
  },
  // ── Voice Intelligence ──
  voice: {
    chat: 'Chat Aria',
    // FAB states
    fab: {
      idle: 'Note vocale',
      recording: 'Enregistrement en cours...',
      uploading: 'Envoi de l\'audio...',
      processing: 'Traitement en cours...',
      done: 'Termine',
      error: 'Erreur',
      permissionDenied: 'Acces au micro refuse',
      maxDuration: 'Duree maximale atteinte',
    },
    // Recorder
    recorder: {
      timer: 'Duree',
      stop: 'Arreter',
      hint: 'Appuyez pour arreter · max 3 min',
      context: 'Bien associe',
    },
    // Processing steps
    processing: {
      transcribing: 'Transcription en cours...',
      extracting: 'Extraction des entites...',
      executed: 'Actions executees',
      steps: 'Etapes de traitement',
    },
    // Legacy keys (used by ProcessingSteps.tsx)
    stepTranscription: 'Transcription',
    stepExtraction: 'Extraction',
    stepExecution: 'Execution',
    processingSteps: 'Etapes de traitement',
    // Results
    results: {
      actionsExecuted: 'Actions executees',
      actionsRolledBack: 'Actions annulees',
      noActions: 'Aucune action detectee',
    },
    // Undo
    undo: {
      title: 'Actions effectuees',
      subtitle: 'Vous pouvez annuler dans les 30 secondes',
      button: 'Annuler',
      expired: 'Delai d\'annulation expire',
      timer: 'Temps restant',
    },
    // Toast
    toast: {
      actionsCount: '{count} actions effectuees',
      undoSuccess: 'Actions annulees avec succes',
    },
    // History
    history: {
      title: 'Historique vocal',
      empty: 'Aucune note vocale — utilisez le bouton micro sur une fiche bien',
      purged: 'Transcript purge',
      status: {
        recording: 'Enregistrement',
        transcribing: 'Transcription',
        extracting: 'Extraction',
        executed: 'Execute',
        undone: 'Annule',
        error: 'Erreur',
      },
    },
    // Action types
    actions: {
      create_rdv: 'Creer un rendez-vous',
      update_pipeline: 'Mettre a jour le pipeline',
      add_note: 'Ajouter une note',
      update_bien: 'Mettre a jour le bien',
    },
    // Errors
    errors: {
      micPermission: 'Veuillez autoriser l\'acces au microphone dans les parametres de votre navigateur.',
      uploadFailed: 'Echec de l\'envoi de l\'audio. Veuillez reessayer.',
      processingFailed: 'Echec du traitement. Veuillez reessayer.',
      undoFailed: 'Echec de l\'annulation.',
      undoExpired: 'Le delai d\'annulation de 30 secondes est expire.',
      consentRequired: 'Le consentement est requis pour enregistrer une note vocale.',
    },
    // Consent
    consent: {
      title: 'Consentement enregistrement',
      description: 'Je confirme etre seul(e) et qu\'aucun tiers n\'est enregistre.',
      checkbox: 'Je confirme',
    },
    // Page
    page: {
      title: 'Notes vocales',
      subtitle: 'Historique de vos dictees vocales',
      filters: 'Filtres',
      noResults: 'Aucune note vocale trouvee',
      notesCount: 'notes',
      freeNote: 'Dictee libre',
      filterStatus: 'Filtrer par statut',
      filterBienId: 'Filtrer par bien (ID)',
      allStatuses: 'Tous les statuts',
      emptyTitle: 'Aucune note vocale',
      emptyDescription: 'Utilisez le bouton micro sur une fiche bien ou depuis la page d\'accueil pour dicter vos notes.',
    },
    // Inline
    inline: {
      sectionTitle: 'Notes vocales',
      recordButton: 'Note vocale',
      recordAriaLabel: 'Enregistrer une note vocale',
      noNotes: 'Aucune note vocale pour ce bien',
      notePrefix: 'Note',
      actionsLabel: 'actions',
      close: 'Fermer',
    },
    // Recording overlay
    recording: {
      label: 'Enregistrement',
      startAriaLabel: 'Demarrer l\'enregistrement vocal',
      stopAriaLabel: 'Arreter l\'enregistrement',
      tapToStop: 'Appuyez pour arreter - max 3 min',
      associatedProperty: 'Bien associe',
      emptyRecording: 'Enregistrement vide. Reessayez.',
    },
  },
  // ── Legal — Voice RGPD ──
  legal: {
    voice: {
      title: 'Notes vocales — Protection des donnees',
      description: 'Les notes vocales sont transcrites automatiquement et le contenu audio est supprime immediatement apres transcription. Le texte brut est conserve 72 heures puis efface. Seules les informations extraites (RDV, statut, notes) sont conservees dans votre dossier.',
      audioRetention: 'Audio : supprime immediatement apres transcription',
      transcriptRetention: 'Transcription brute : conservee 72 heures puis effacee',
      entitiesRetention: 'Donnees extraites : conservees pour la duree du mandat + 5 ans',
    },
  },

  readAloud: {
    title: 'Brief pré-visite',
    generate: 'Générer le brief',
    generating: 'Aria prépare votre brief…',
    sections: {
      property: 'Le Bien',
      buyer: "L'Acheteur",
      preparation: 'Préparation',
      logistics: 'Infos pratiques',
    },
    cacheExpiry: 'Valide jusqu\'à {{time}}',
    notification: {
      title: 'Visite dans {{minutes}} min',
      body: '{{address}} — Appuyer pour écouter le brief',
    },
    error: {
      insufficientData: 'Données insuffisantes. Vérifier la fiche bien et acheteur.',
    },
  },
}

// Recursive type that preserves structure but allows any string values
type DeepStringify<T> = {
  [K in keyof T]: T[K] extends string ? string : DeepStringify<T[K]>
}

export type Translations = DeepStringify<typeof fr>
